<template>
  <f7-page name="control-cifras" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link back icon-f7="arrow_left"></f7-link>
        <div class="btn-info" @click.stop="popupInfo = !popupInfo; if (popupInfo && !instrucciones.length) inicializarInst()" :class="{'btn-info-activo': popupInfo}"><span>i</span></div>
      </f7-nav-left>
      <f7-nav-title>Control de cifras OEA</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="zoomOut" style="font-size:12px;min-width:20px">−</f7-link>
        <span style="font-size:11px;min-width:30px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoomIn" style="font-size:12px;min-width:20px">+</f7-link>
        <f7-link icon-f7="arrow_2_circlepath" @click="actualizarCifras" title="Actualizar cifras"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #26 · Ya no dice "En vivo". La ficha se enriquece (ausencias, dias reales, objetivos) en
         cada peticion, eso es cierto, pero las CIFRAS que enseña esta pantalla no: entran por
         "Actualizar cifras" y por el cron de 30 minutos, asi que pueden ser de hace dias. Las dos
         frases juntas se contradecian, y el sello dice de cuando son las cifras. Sin marca —ficha
         anterior a #26, que no se rellena hacia atras— SelloDatos se degrada a "no se sabe" en vez
         de inventar una fecha.
         Y para que el sello diga la verdad, getFichaControlCifras se pide sin la cache de
         peticiones de DatabaseModel (60 s): la ficha la tocan varias personas, y tirarla tras
         mutacion solo cubre lo que se guarda en este navegador.
         Mientras carga no se enseña: al recargar el mismo mes la ficha se conserva hasta que
         responde la peticion (#769), y lo que se esta recalculando es justo esa antiguedad. -->
    <div class="sello-datos-bar">
      <sello-datos v-if="!cargando" estado="fecha" :fecha="ficha && ficha.cifrasTpcCargadasEn"
        nota="Cifras TPC" />
    </div>

    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL','COMERCIAL']">
      <div class="contenido-oea" :style="{ fontSize: (zoom * 0.12) + 'px' }">
      <!-- SELECTOR DE MES -->
      <div class="mes-selector">
        <f7-link @click="mesPrevio" icon-f7="chevron_left"></f7-link>
        <select v-model="anio" @change="cargarFicha" class="select-anio">
          <option v-for="a in aniosDisponibles" :key="a" :value="a">{{ a }}</option>
        </select>
        <select v-model="mes" @change="cargarFicha" class="select-mes">
          <option v-for="(nombre, idx) in nombresMeses" :key="idx" :value="idx + 1">{{ nombre }}</option>
        </select>
        <span class="mes-badge" :class="'badge-' + (ficha ? ficha.estado : '')">
          {{ ficha ? ficha.estado : '' }}
        </span>
        <f7-link @click="mesSiguiente" icon-f7="chevron_right"></f7-link>
      </div>

      <!-- MÉTRICAS GLOBALES -->
      <div class="metricas-grid" v-if="ficha && ficha.totales">
        <div class="metrica-card">
          <div class="metrica-label">Progresión total <info-icon dominio="oea" clave="OEA_PROGRESION" criticidad="CRITICO" pantalla="control-cifras" /></div>
          <div class="metrica-valor">{{ formatImporte(ficha.totales.progresionTotal) }}</div>
        </div>
        <div class="metrica-card">
          <div class="metrica-label">Objetivo mes <info-icon dominio="oea" clave="OEA_ObjetivoMes" criticidad="CRITICO" pantalla="control-cifras" /></div>
          <div class="metrica-valor">{{ formatImporte(ficha.totales.objetivoMensualTotal) }}</div>
        </div>
        <div class="metrica-card">
          <div class="metrica-label">Falta para llegar <info-icon dominio="oea" clave="OEA_FaltaTotal" criticidad="CRITICO" pantalla="control-cifras" /></div>
          <div class="metrica-valor" :class="ficha.totales.faltaTotal >= 0 ? 'valor-positivo' : 'valor-negativo'">
            {{ formatImporteConSigno(ficha.totales.faltaTotal) }}
          </div>
        </div>
        <div class="metrica-card">
          <div class="metrica-label">% cumplimiento <info-icon dominio="oea" clave="OEA_PctCumplimiento" criticidad="CRITICO" pantalla="control-cifras" /></div>
          <div class="metrica-valor" :class="'color-' + calcularEstadoColor(ficha.totales.porcentajeGlobal)">
            {{ formatPorcentaje(ficha.totales.porcentajeGlobal) }}
          </div>
        </div>
      </div>

      <!-- INFO ACTUALIZACIÓN -->
      <div class="info-actualizacion" v-if="ficha">
        <span>Última actualización: {{ formatFecha(ficha.modificationDate) }}</span>
        <span> · Cada 30 min</span>
      </div>

      <!-- BOTONES DE ACCIÓN -->
      <div class="acciones-bar" v-if="ficha">
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small fill color="green" @click="crearMesSiguiente" v-roles="['ADMIN','DIRECTOR','DTYCAL']">+ Crear {{ nombreMesSiguiente }}</f7-button>
          <info-icon dominio="oea" clave="OEA_CrearMesSiguiente" criticidad="CRITICO" pantalla="control-cifras" @click.native.stop />
        </span>
        <!-- #34 · Guardar y + Persona solo para Administrador en OEA (en OEB entra tambien
             Direccion). Quien no tenga el rol no ve el boton, no es que no le funcione. -->
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small fill color="blue" @click="guardarPersonasVisibles" :disabled="guardandoPersonas" v-roles="['ADMIN']">{{ guardandoPersonas ? 'Guardando...' : 'Guardar' }}</f7-button>
        </span>
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small outline @click="agregarPersona" v-roles="['ADMIN']">+ Persona</f7-button>
          <info-icon dominio="oea" clave="OEA_AnadirPersona" criticidad="CRITICO" pantalla="control-cifras" @click.native.stop />
        </span>
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small outline @click="enviarReporte" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Enviar reporte</f7-button>
          <info-icon dominio="oea" clave="OEA_EnviarReporte" criticidad="CRITICO" pantalla="control-cifras" @click.native.stop />
        </span>
        <span v-if="closers.length" style="display:inline-flex;align-items:center;gap:4px" title="Muestra las ventas cerradas como closer (filas informativas, NO suman a ningún total)">
          <f7-button small :fill="mostrarClosers" :outline="!mostrarClosers" color="purple" @click="mostrarClosers = !mostrarClosers">Closer</f7-button>
        </span>
        <span style="display:inline-flex;align-items:center;gap:4px">
          <f7-button small outline @click="irANotificaciones" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Programar envíos</f7-button>
          <info-icon dominio="oea" clave="OEA_ProgramarEnvios" criticidad="CRITICO" pantalla="control-cifras" @click.native.stop />
        </span>
      </div>

      <!-- INDICADORES GLOBALES (8 tarjetas) — #40 · lo mismo que hay arriba en Control de cifras
           OEB, sin las tres de producción (Nº I/C, Horas comp., Productividad I/C) que aquí no
           aplican. Las cinco de días se sirven de totalesDias, que es lo que pinta la fila TOTAL
           de la tabla: así no pueden discrepar de ella. -->
      <div class="indicadores-grid" v-if="ficha && ficha.personas">
        <div class="ind-card ind-gris"><div class="ind-label">Personas <info-icon dominio="oea" clave="OEA_Personas" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ personasOrdenadas.length }}</div></div>
        <div class="ind-card ind-gris"><div class="ind-label">D&iacute;as h&aacute;biles <info-icon dominio="oea" clave="OEB_DH" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ totalesDias.diasHabiles }}</div></div>
        <div class="ind-card ind-amarillo"><div class="ind-label">Fiestas <info-icon dominio="oea" clave="OEB_Fiestas" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ totalesDias.fiestas || '—' }}</div></div>
        <div class="ind-card ind-amarillo"><div class="ind-label">Vacaciones <info-icon dominio="oea" clave="OEB_VAC" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ totalesDias.vacaciones || '—' }}</div></div>
        <div class="ind-card ind-rojo"><div class="ind-label">Bajas laborales <info-icon dominio="oea" clave="OEB_BL" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ totalesDias.bajas || '—' }}</div></div>
        <div class="ind-card ind-gris"><div class="ind-label">D&iacute;as reales <info-icon dominio="oea" clave="OEB_DR" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ totalesDias.diasReales }}</div></div>
        <div class="ind-card ind-azul"><div class="ind-label">N&ordm; horas mes <info-icon dominio="oea" clave="OEA_NumHorasMes" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ indTotalHorasMes || '—' }}</div></div>
        <div class="ind-card ind-azul"><div class="ind-label">Productividad ventas <info-icon dominio="oea" clave="OEA_ProductividadVentas" criticidad="CRITICO" pantalla="control-cifras" /></div><div class="ind-val">{{ indProductividadVentas }}</div></div>
      </div>

      <!-- TABLA PRINCIPAL — Estructura idéntica al Excel -->
      <div class="tabla-container" v-if="ficha && ficha.personas && ficha.personas.length > 0">
        <div class="tabla-scroll">
          <table class="tabla-oea">
            <thead>
              <tr>
                <th class="col-sticky col-codigo">Cód.</th>
                <!-- Bloque 2: Contratación semanal -->
                <th class="col-sem col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'hc-'+sem.numero">
                  S{{ sem.numero }}<br><span class="sem-fechas">{{ extraerDias(sem) }}</span>
                </th>
                <!-- Bloque 3: Resumen -->
                <th class="col-progresion col-sep-left">Progr. <info-icon dominio="oea" clave="OEA_PROGRESION" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <th class="col-num">Obj.Mes <info-icon dominio="oea" clave="OEA_ObjetivoMes" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <th class="col-num">Falta <info-icon dominio="oea" clave="OEA_FaltaTotal" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <th class="col-pct">% <info-icon dominio="oea" clave="OEA_PctCumplimiento" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <!-- Bloque 4: Días -->
                <th class="col-dia col-sep-left">D.H <info-icon dominio="oea" clave="OEB_DH" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <th class="col-dia">Vac <info-icon dominio="oea" clave="OEB_VAC" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <th class="col-dia" title="D&iacute;as de baja laboral (T0084) del mes">BL</th>
                <th class="col-dia" title="D&iacute;as de fiesta individual (T0083) del mes">FIES</th>
                <th class="col-dia" title="Horas de compensaci&oacute;n (T0085) del mes">COMP</th>
                <th class="col-dia">D.R <info-icon dominio="oea" clave="OEB_DR" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <!-- Bloque 5: Días por semana -->
                <th class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'hd-'+sem.numero">
                  S{{ sem.numero }}
                </th>
                <!-- Bloque 6: Obj diario -->
                <th class="col-num col-sep-left">T.DÍA <info-icon dominio="oea" clave="OEA_TDIA" criticidad="CRITICO" pantalla="control-cifras" /></th>
                <!-- Bloque 7: Objetivo semanal -->
                <th class="col-sem col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'ho-'+sem.numero">
                  S{{ sem.numero }}
                </th>
                <!-- Bloque 8: Total -->
                <th class="col-num col-sep-left">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="persona in personasOrdenadas" :key="persona.codigoPersonal"
                  @click="abrirDetallePersona(persona)" class="fila-persona">
                <td class="col-sticky col-codigo"><strong>{{ persona.codigoPersonal }}</strong></td>
                <!-- Bloque 2: Contratación semanal -->
                <td class="col-sem col-sep-left" v-for="(resultado, idx) in persona.resultadosSemana" :key="'rc-'+idx"
                    :style="colorCeldaSemana(persona, idx)">
                  {{ resultado > 0 ? formatImporteCorto(resultado) : '—' }}
                </td>
                <!-- Bloque 3: Resumen -->
                <td class="col-progresion col-sep-left" :style="colorProgresionMensual(persona)"><strong>{{ formatImporteCorto(persona.progresionMes) }}</strong></td>
                <td class="col-num">{{ formatImporteCorto(persona.objetivoMensual) }}</td>
                <td class="col-num" :class="persona.faltaParaLlegar >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  {{ formatImporteConSigno(persona.faltaParaLlegar) }}
                </td>
                <td class="col-pct">
                  <span class="badge-estado" :class="'estado-' + persona.estadoColor">{{ formatPorcentaje(persona.porcentajeCumplimiento) }}</span>
                </td>
                <!-- Bloque 4: Días -->
                <td class="col-dia col-sep-left">{{ calcularDiasHabilesPersona(persona) }}</td>
                <td class="col-dia">{{ vacPersona(persona) || '—' }}</td>
                <td class="col-dia">{{ blPersona(persona) || '—' }}</td>
                <td class="col-dia">{{ fiestasPersona(persona) || '—' }}</td>
                <td class="col-dia">{{ compPersona(persona) || '—' }}</td>
                <td class="col-dia">{{ persona.diasReales || 0 }}</td>
                <!-- Bloque 5: Días por semana -->
                <td class="col-dia col-sep-left" v-for="(sem, idx) in persona.semanas" :key="'ds-'+idx"
                    :class="{'dia-modificado': sem.modificado}">
                  {{ sem.diasReales != null ? sem.diasReales : sem.diasHabiles }}
                </td>
                <!-- Bloque 6: Obj diario -->
                <td class="col-num col-sep-left">{{ formatImporteCorto(persona.objetivoDiarioActual) }}</td>
                <!-- Bloque 7: Objetivo semanal -->
                <td class="col-sem col-sep-left" v-for="(obj, idx) in persona.objetivosSemana" :key="'os-'+idx">
                  {{ formatImporteCorto(obj) }}
                </td>
                <!-- Bloque 8: Total -->
                <td class="col-num col-sep-left">{{ formatImporteCorto(persona.objetivoMensual) }}</td>
              </tr>
              <!-- Filas CLOSER (informativas): fuera de personas, NUNCA suman a totales/KPIs/grupos -->
              <template v-if="mostrarClosers">
                <tr v-for="c in closers" :key="'closer-'+c.codigo" class="fila-closer"
                    :title="(c.nombre || c.codigo) + ' — importe cerrado como closer de ventas de otros. Informativo: no suma a ningún total.'">
                  <td class="col-sticky col-codigo"><strong>{{ c.codigo }}</strong> <span class="badge-closer">closer</span></td>
                  <td class="col-sem col-sep-left" v-for="(imp, idx) in c.porSemana" :key="'clw-'+idx">
                    {{ imp > 0 ? formatImporteCorto(imp) : '—' }}
                  </td>
                  <td class="col-progresion col-sep-left"><strong>{{ formatImporteCorto(c.total) }}</strong></td>
                  <td class="col-num">—</td>
                  <td class="col-num">—</td>
                  <td class="col-pct">—</td>
                  <td colspan="6" class="col-sep-left"></td>
                  <td class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'cld-'+sem.numero"></td>
                  <td class="col-sep-left"></td>
                  <td class="col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'clo-'+sem.numero"></td>
                  <td class="col-sep-left"></td>
                </tr>
              </template>
            </tbody>
            <tfoot v-if="ficha.totales">
              <!-- Fila TOTAL -->
              <tr class="fila-totales">
                <td class="col-sticky col-codigo"><strong>TOTAL</strong></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'tc-'+semT.semanaNumero">
                  <strong>{{ formatImporteCorto(semT.resultadoSemana) }}</strong>
                </td>
                <td class="col-progresion col-sep-left"><strong>{{ formatImporteCorto(ficha.totales.progresionTotal) }}</strong></td>
                <td class="col-num"><strong>{{ formatImporteCorto(ficha.totales.objetivoMensualTotal) }}</strong></td>
                <td class="col-num" :class="ficha.totales.faltaTotal >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  <strong>{{ formatImporteConSigno(ficha.totales.faltaTotal) }}</strong>
                </td>
                <td class="col-pct">
                  <span class="badge-estado" :class="'estado-' + calcularEstadoColor(ficha.totales.porcentajeGlobal)">{{ formatPorcentaje(ficha.totales.porcentajeGlobal) }}</span>
                </td>
                <td class="col-dia col-sep-left"><strong>{{ totalesDias.diasHabiles }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.vacaciones || '—' }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.bajas || '—' }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.fiestas || '—' }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.compensacion || '—' }}</strong></td>
                <td class="col-dia"><strong>{{ totalesDias.diasReales }}</strong></td>
                <td class="col-dia col-sep-left" v-for="(sem, idx) in ficha.calendario.semanas" :key="'td-'+sem.numero">
                  <strong>{{ totalesDiasSemana[idx] }}</strong>
                </td>
                <td class="col-sep-left"></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'to-'+semT.semanaNumero">
                  <strong>{{ formatImporteCorto(semT.objetivoSemana) }}</strong>
                </td>
                <td class="col-num col-sep-left"><strong>{{ formatImporteCorto(ficha.totales.objetivoMensualTotal) }}</strong></td>
              </tr>
              <!-- Fila OBJ.SEM -->
              <tr class="fila-obj-sem">
                <td class="col-sticky col-codigo">OBJ.SEM <info-icon dominio="oea" clave="OEA_ObjetivoSemanal" criticidad="CRITICO" pantalla="control-cifras" /></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'os2-'+semT.semanaNumero">
                  {{ formatImporteCorto(semT.objetivoSemana) }}
                </td>
                <td class="col-progresion col-sep-left">{{ formatImporteCorto(ficha.totales.objetivoMensualTotal) }}</td>
                <td colspan="3"></td>
                <td colspan="6" class="col-sep-left"></td>
                <td class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'od-'+sem.numero"></td>
                <td class="col-sep-left"></td>
                <td class="col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'oo-'+sem.numero"></td>
                <td class="col-sep-left"></td>
              </tr>
              <!-- Fila FALTA -->
              <tr class="fila-dif-sem">
                <td class="col-sticky col-codigo">FALTA <info-icon dominio="oea" clave="OEA_FaltaTotal" criticidad="CRITICO" pantalla="control-cifras" /></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'fs-'+semT.semanaNumero"
                    :class="semT.diferencia >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  {{ formatImporteConSigno(semT.diferencia) }}
                </td>
                <td class="col-progresion col-sep-left" :class="ficha.totales.faltaTotal >= 0 ? 'valor-positivo' : 'valor-negativo'">
                  {{ formatImporteConSigno(ficha.totales.faltaTotal) }}
                </td>
                <td colspan="3"></td>
                <td colspan="6" class="col-sep-left"></td>
                <td class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'fd-'+sem.numero"></td>
                <td class="col-sep-left"></td>
                <td class="col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'fo-'+sem.numero"></td>
                <td class="col-sep-left"></td>
              </tr>
              <!-- Fila % OBJ -->
              <tr class="fila-pct-sem">
                <td class="col-sticky col-codigo">% OBJ <info-icon dominio="oea" clave="OEA_PctCumplimiento" criticidad="CRITICO" pantalla="control-cifras" /></td>
                <td class="col-sem col-sep-left" v-for="semT in ficha.totales.porSemana" :key="'ps2-'+semT.semanaNumero">
                  <span class="badge-estado" :class="'estado-' + calcularEstadoColor(semT.porcentaje)">{{ formatPorcentaje(semT.porcentaje) }}</span>
                </td>
                <td class="col-progresion col-sep-left">
                  <span class="badge-estado" :class="'estado-' + calcularEstadoColor(ficha.totales.porcentajeGlobal)">{{ formatPorcentaje(ficha.totales.porcentajeGlobal) }}</span>
                </td>
                <td colspan="3"></td>
                <td colspan="6" class="col-sep-left"></td>
                <td class="col-dia col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'pd-'+sem.numero"></td>
                <td class="col-sep-left"></td>
                <td class="col-sep-left" v-for="sem in ficha.calendario.semanas" :key="'po-'+sem.numero"></td>
                <td class="col-sep-left"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <!-- LEYENDA DE COLORES -->
      <div class="leyenda" v-if="ficha">
        <span class="leyenda-item"><span class="dot estado-MUY_BUENO"></span> Muy bueno &gt;105% <info-icon dominio="oea" clave="OEA_EstadoCumplimiento" criticidad="CRITICO" pantalla="control-cifras" /></span>
        <span class="leyenda-item"><span class="dot estado-BUENO"></span> Bueno 100-105%</span>
        <span class="leyenda-item"><span class="dot estado-MALO"></span> Malo 95-100%</span>
        <span class="leyenda-item"><span class="dot estado-MUY_MALO"></span> Muy malo &lt;95%</span>
      </div>

      <!-- RESUMEN POR CLASIFICACIÓN -->
      <div class="resumen-clasificacion" v-if="ficha && ficha.personas">
        <table class="tabla-resumen-cls">
          <thead>
            <tr>
              <th>Grupo <info-icon dominio="oea" clave="OEA_Clasificacion" criticidad="CRITICO" pantalla="control-cifras" /></th>
              <th>Total resultado <info-icon dominio="oea" clave="OEA_TotalResultado" criticidad="CRITICO" pantalla="control-cifras" /></th>
              <th>OEA al mes <info-icon dominio="oea" clave="OEA_OEAAlMes" criticidad="CRITICO" pantalla="control-cifras" /></th>
              <th>Diferencia <info-icon dominio="oea" clave="OEA_Diferencia" criticidad="CRITICO" pantalla="control-cifras" /></th>
              <th>% del obj. <info-icon dominio="oea" clave="OEA_PctDelObjetivo" criticidad="CRITICO" pantalla="control-cifras" /></th>
              <th>% del total <info-icon dominio="oea" clave="OEA_PctDelTotal" criticidad="CRITICO" pantalla="control-cifras" /></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="grupo in resumenPorClasificacion" :key="grupo.clasificacion">
              <td><span class="badge-cls" :class="'badge-' + grupo.clasificacion.replace('/', '')">{{ grupo.clasificacion }}</span></td>
              <td><strong>{{ formatImporte(grupo.totalResultado) }}</strong></td>
              <td>{{ formatImporte(grupo.totalObjetivo) }}</td>
              <td :class="grupo.diferencia >= 0 ? 'valor-positivo' : 'valor-negativo'">
                {{ formatImporteConSigno(grupo.diferencia) }}
              </td>
              <td>
                <span class="badge-estado" :class="'estado-' + calcularEstadoColor(grupo.porcentaje)">
                  {{ formatPorcentaje(grupo.porcentaje) }}
                </span>
              </td>
              <td>{{ grupo.porcentajeTotal }}%</td>
            </tr>
            <tr v-if="ficha.totales" class="fila-totales">
              <td><strong>TOTAL</strong></td>
              <td><strong>{{ formatImporte(ficha.totales.progresionTotal) }}</strong></td>
              <td><strong>{{ formatImporte(ficha.totales.objetivoMensualTotal) }}</strong></td>
              <td :class="ficha.totales.faltaTotal >= 0 ? 'valor-positivo' : 'valor-negativo'">
                <strong>{{ formatImporteConSigno(ficha.totales.faltaTotal) }}</strong>
              </td>
              <td>
                <span class="badge-estado" :class="'estado-' + calcularEstadoColor(ficha.totales.porcentajeGlobal)">
                  {{ formatPorcentaje(ficha.totales.porcentajeGlobal) }}
                </span>
              </td>
              <td>100%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- MENSAJE SI NO HAY FICHA -->
      <f7-block v-if="!ficha && !cargando" class="text-align-center">
        <p>No hay ficha para {{ nombreMes }} {{ anio }}</p>
        <f7-button fill color="green" @click="crearFichaMes" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Crear ficha de {{ nombreMes }} {{ anio }}</f7-button>
      </f7-block>

      <!-- LOADING -->
      <f7-block v-if="cargando" class="text-align-center">
        <f7-preloader></f7-preloader>
        <p>Cargando datos...</p>
      </f7-block>
      </div>
    </f7-page-content>

    <!-- POPUP DETALLE PERSONA -->
    <f7-popup :opened="popupAbierto" @popup:closed="popupAbierto = false" class="popup-persona">
      <f7-page v-if="personaSel" :page-content="true">
        <f7-navbar title="">
          <f7-nav-right>
            <f7-link popup-close icon-f7="xmark"></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div style="text-align:center;padding:12px 0 4px;font-size:18px;font-weight:700;color:#1a2744">{{ personaSel.codigoPersonal }}</div>
        <f7-block-title>Clasificación <info-icon dominio="oea" clave="OEA_Clasificacion" criticidad="CRITICO" pantalla="control-cifras" /></f7-block-title>
        <f7-block strong>
          <div style="display:flex;gap:8px">
            <button :style="{padding:'6px 16px',borderRadius:'8px',border:'1px solid #ddd',cursor:'pointer',fontWeight:'500',background:personaSel.clasificacion==='GC'?'#BA7517':'#f5f5f5',color:personaSel.clasificacion==='GC'?'white':'#333'}" @click="guardarClasificacion(personaSel,'GC')">GC</button>
            <button :style="{padding:'6px 16px',borderRadius:'8px',border:'1px solid #ddd',cursor:'pointer',fontWeight:'500',background:personaSel.clasificacion==='FV'?'#185FA5':'#f5f5f5',color:personaSel.clasificacion==='FV'?'white':'#333'}" @click="guardarClasificacion(personaSel,'FV')">FV</button>
            <button :style="{padding:'6px 16px',borderRadius:'8px',border:'1px solid #ddd',cursor:'pointer',fontWeight:'500',background:personaSel.clasificacion==='I/C'?'#534AB7':'#f5f5f5',color:personaSel.clasificacion==='I/C'?'white':'#333'}" @click="guardarClasificacion(personaSel,'I/C')">I/C</button>
          </div>
        </f7-block>
        <f7-block-title>Objetivo diario</f7-block-title>
        <f7-block strong>
          <div style="display:flex;align-items:center;gap:8px">
            <input type="number" v-model.number="objetivoEditable" step="1" min="0" style="width:100px;padding:6px 8px;border:1px solid #ddd;border-radius:6px;font-size:15px;font-weight:500;text-align:right" />
            <span style="font-size:13px;color:#888">€/día</span>
            <button style="padding:6px 14px;background:#0F6E56;color:white;border:none;border-radius:6px;font-size:12px;cursor:pointer" @click="guardarObjetivo(personaSel)">Guardar</button>
          </div>
          <div style="margin-top:6px;font-size:12px;color:#888">Objetivo mensual: <strong>{{ formatImporte(calcularObjMensual()) }}</strong></div>
        </f7-block>
        <f7-block-title>Días hábiles por semana</f7-block-title>
        <f7-block strong>
          <table style="width:100%;border-collapse:collapse;font-size:12px">
            <thead>
              <tr>
                <th style="padding:4px;text-align:left;font-size:11px;color:#888;border-bottom:1px solid #ddd">Semana</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Días</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Orig.</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Vac.</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">BL</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Fiest.</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Comp.</th>
                <th style="padding:4px;text-align:right;font-size:11px;color:#888;border-bottom:1px solid #ddd">Obj.sem</th>
                <th style="padding:4px;text-align:center;font-size:11px;color:#888;border-bottom:1px solid #ddd">Estado</th>
                <th style="padding:4px;border-bottom:1px solid #ddd"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sem, idx) in personaSel.semanas" :key="'pd-'+sem.semanaNumero" style="border-bottom:1px solid #f0f0f0">
                <td style="padding:4px"><strong>S{{ sem.semanaNumero }}</strong> <span style="font-size:10px;color:#aaa">{{ obtenerRangoSemana(sem.semanaNumero) }}</span></td>
                <td style="padding:4px;text-align:center"><strong>{{ sem.diasReales != null ? sem.diasReales : sem.diasHabiles }}</strong></td>
                <td style="padding:4px;text-align:center;color:#aaa">{{ sem.diasHabilesOriginal }}</td>
                <td style="padding:4px;text-align:center" :style="dsg('vacsSem',idx)>0 ? 'background:#FFF9E6;color:#856404;font-weight:500' : 'color:#ccc'">{{ dsg('vacsSem',idx) || '·' }}</td>
                <td style="padding:4px;text-align:center" :style="dsg('bajasSem',idx)>0 ? 'background:#FCEBEB;color:#A32D2D;font-weight:500' : 'color:#ccc'">{{ dsg('bajasSem',idx) || '·' }}</td>
                <td style="padding:4px;text-align:center" :style="dsg('fiestasSem',idx)>0 ? 'background:#FAEEDA;color:#633806;font-weight:500' : 'color:#ccc'">{{ dsg('fiestasSem',idx) || '·' }}</td>
                <td style="padding:4px;text-align:center" :style="dsg('compSem',idx)>0 ? 'background:#E6F1FB;color:#0C447C;font-weight:500' : 'color:#ccc'">{{ dsg('compSem',idx)>0 ? dsg('compSem',idx).toFixed(1) : '·' }}</td>
                <td style="padding:4px;text-align:right">{{ formatImporteCorto(personaSel.objetivoDiarioActual * (sem.diasReales != null ? sem.diasReales : sem.diasHabiles)) }}</td>
                <td style="padding:4px;text-align:center">
                  <span v-if="sem.modificado" style="background:#FAEEDA;color:#633806;font-size:10px;padding:2px 6px;border-radius:8px;cursor:pointer" @click="verNotaDias(sem)">Modificado</span>
                  <span v-else style="color:#aaa;font-size:10px">OK</span>
                </td>
                <td style="padding:4px"><button style="padding:2px 8px;border:1px solid #ddd;border-radius:4px;background:white;font-size:10px;cursor:pointer" @click="editarDiaSemana(sem)">Editar</button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="border-top:2px solid #ccc;font-weight:500">
                <td style="padding:6px 4px">TOTAL</td>
                <td style="padding:6px 4px;text-align:center">{{ personaSel.diasReales != null ? personaSel.diasReales : '-' }}</td>
                <td style="padding:6px 4px;text-align:center;color:#aaa">{{ totalOrig() }}</td>
                <td style="padding:6px 4px;text-align:center;background:#FFF9E6;color:#856404">{{ totalDsg('vacsSem') }}</td>
                <td style="padding:6px 4px;text-align:center;background:#FCEBEB;color:#A32D2D">{{ totalDsg('bajasSem') }}</td>
                <td style="padding:6px 4px;text-align:center;background:#FAEEDA;color:#633806">{{ totalDsg('fiestasSem') }}</td>
                <td style="padding:6px 4px;text-align:center;background:#E6F1FB;color:#0C447C">{{ compTotalPersona().toFixed(1) }}</td>
                <td style="padding:6px 4px;text-align:right">{{ formatImporteCorto(calcularObjMensual()) }}</td>
                <td></td><td></td>
              </tr>
            </tfoot>
          </table>
        </f7-block>
        <f7-block-title>Resumen del mes</f7-block-title>
        <f7-block strong>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">
            <div><span style="font-size:11px;color:#888;display:block">Progresión</span><span style="font-size:16px;font-weight:500">{{ formatImporte(personaSel.progresionMes) }}</span></div>
            <div><span style="font-size:11px;color:#888;display:block">Objetivo</span><span style="font-size:16px;font-weight:500">{{ formatImporte(personaSel.objetivoMensual) }}</span></div>
            <div><span style="font-size:11px;color:#888;display:block">Falta</span><span style="font-size:16px;font-weight:500" :class="personaSel.faltaParaLlegar>=0?'valor-positivo':'valor-negativo'">{{ formatImporteConSigno(personaSel.faltaParaLlegar) }}</span></div>
            <div><span style="font-size:11px;color:#888;display:block">Cumplimiento</span><span class="badge-estado" :class="'estado-'+personaSel.estadoColor">{{ formatPorcentaje(personaSel.porcentajeCumplimiento) }}</span></div>
          </div>
        </f7-block>
        <f7-block-title v-if="historialPersona.length>0">Historial de cambios</f7-block-title>
        <f7-block strong v-if="historialPersona.length>0">
          <table style="width:100%;border-collapse:collapse;font-size:10px;table-layout:fixed">
            <thead><tr><th style="padding:3px;text-align:left;color:#888;border-bottom:1px solid #ddd;width:60px">Persona</th><th style="padding:3px;text-align:left;color:#888;border-bottom:1px solid #ddd;width:65px">Fecha</th><th style="padding:3px;text-align:left;color:#888;border-bottom:1px solid #ddd;width:120px">Campo</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd;width:70px">Anterior</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd;width:70px">Nuevo</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd;width:60px">Usuario</th><th style="padding:3px;color:#888;border-bottom:1px solid #ddd">Motivo</th></tr></thead>
            <tbody><tr v-for="(c,i) in historialPersona" :key="'h-'+i" style="border-bottom:1px solid #f0f0f0"><td style="padding:3px">{{ personaSel.codigoPersonal }}</td><td style="padding:3px">{{ c.fecha ? new Date(c.fecha).toLocaleDateString('es-ES') : '' }}</td><td style="padding:3px">{{ c.campo }}</td><td style="padding:3px">{{ c.valorAnterior }}</td><td style="padding:3px">{{ c.valorNuevo }}</td><td style="padding:3px">{{ c.usuario }}</td><td style="padding:3px">{{ c.motivo || '' }}</td></tr></tbody>
          </table>
        </f7-block>
        <!-- #34 · Mismo rol que + Persona. No borra sus cifras del mes: deja de verse. -->
        <f7-block><f7-button fill color="red" @click="quitarPersona(personaSel)" v-roles="['ADMIN']">Quitar del mes</f7-button></f7-block>
      </f7-page>
    </f7-popup>

    <!-- POPUP GUÍA DE USO -->
    <f7-popup :opened="popupInfo" @popup:close="fullscreen = false; popupInfo = false" class="ct-popup-guia" :style="fullscreen ? '--f7-popup-tablet-width:95vw;--f7-popup-tablet-height:95vh' : ''">
      <f7-page :page-content="false">
        <f7-navbar title="Guía de uso" style="display:none"></f7-navbar>
        <div class="ct-hdr" style="background:linear-gradient(135deg,#0F6E56,#27ae80)">
          <div class="ct-hdr-top">
            <div class="ct-hdr-left">
              <span class="ct-hdr-ico">📈</span>
              <div><div class="ct-hdr-title">Guía de uso</div><div class="ct-hdr-sub">CONTROL DE CIFRAS OEA</div></div>
            </div>
            <div class="ct-hdr-right">
              <span class="ct-hdr-badge">{{ instFiltradas.length }} instrucciones</span>
              <button class="ct-hdr-add" @click="nuevaInst">+</button>
              <button class="ct-hdr-close" @click="fullscreen = !fullscreen">{{ fullscreen ? '⇖' : '⛶' }}</button>
              <button class="ct-hdr-close" @click="fullscreen = false; popupInfo = false">✕</button>
            </div>
          </div>
          <div class="ct-search-wrap">
            <span class="ct-search-ico">🔍</span>
            <input class="ct-search" type="text" placeholder="Buscar instrucciones..." v-model="busquedaInst">
            <button v-if="busquedaInst" class="ct-search-x" @click="busquedaInst = ''">✕</button>
          </div>
        </div>
        <f7-page-content class="ct-body">
          <div v-if="instFiltradas.length" class="ct-counter">{{ instFiltradas.length }} instrucciones</div>
          <div v-if="!instFiltradas.length" class="ct-empty"><span style="font-size:32px;opacity:.3">📈</span><p>Sin instrucciones. Pulsa + para crear.</p></div>
          <div v-for="(inst, idx) in instFiltradas" :key="inst.id" class="ct-card" style="border-left-color:#0F6E56"
            draggable="true" @dragstart="draggingInst = idx" @dragover.prevent @drop="dropInst(idx)">
            <div class="ct-card-hdr" @click="expandedInst === inst.id ? expandedInst = null : expandedInst = inst.id">
              <span class="ct-card-num" style="background:#0F6E56">{{ idx + 1 }}</span>
              <div class="ct-card-title-area"><div class="ct-card-title">{{ inst.titulo }}</div></div>
              <span class="ct-card-chev">{{ expandedInst === inst.id ? '▲' : '▼' }}</span>
            </div>
            <div v-if="expandedInst === inst.id" class="ct-card-body">
              <template v-if="inst._editando">
                <div class="ct-form-field"><label>Título</label><input type="text" v-model="inst.titulo"></div>
                <div class="ct-form-field"><label>Contenido</label><textarea v-model="inst.texto" rows="4"></textarea></div>
                <div class="ct-form-btns">
                  <button class="ct-fbtn ct-fbtn-ok" @click="guardarInst(inst)">Guardar</button>
                  <button class="ct-fbtn ct-fbtn-cancel" @click="inst._editando = false">Cancelar</button>
                </div>
              </template>
              <template v-else>
                <div class="ct-card-content">{{ inst.texto }}</div>
                <div class="ct-card-actions">
                  <button @click.stop="$set(inst, '_editando', true)">✏️ Editar</button>
                  <button @click.stop="eliminarInst(inst)">🗑️ Eliminar</button>
                </div>
              </template>
            </div>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>

    <!-- POPUP ENVIAR REPORTE -->
    <f7-popup :opened="popupReporte" @popup:closed="popupReporte = false" class="popup-reporte">
      <f7-page>
        <f7-navbar title="Enviar informe OEA">
          <f7-nav-right><f7-link popup-close icon-f7="xmark"></f7-link></f7-nav-right>
        </f7-navbar>
        <f7-page-content>
          <f7-block-title>Tipo de informe</f7-block-title>
          <f7-block strong>
            <div style="display:flex;gap:8px">
              <div @click="reporteTipo = 'DIARIO'; actualizarAsuntoReporte()" style="flex:1;padding:10px;text-align:center;border-radius:8px;cursor:pointer;font-size:12px;font-weight:600" :style="reporteTipo === 'DIARIO' ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)',color:'#1a2744'} : {border:'1px solid #ddd',color:'#64748b'}">
                <div>Diario</div><div style="font-size:10px;font-weight:400;margin-top:2px">Hoy + acumulado</div>
              </div>
              <div @click="reporteTipo = 'SEMANAL'; actualizarAsuntoReporte()" style="flex:1;padding:10px;text-align:center;border-radius:8px;cursor:pointer;font-size:12px;font-weight:600" :style="reporteTipo === 'SEMANAL' ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)',color:'#1a2744'} : {border:'1px solid #ddd',color:'#64748b'}">
                <div>Semanal</div><div style="font-size:10px;font-weight:400;margin-top:2px">Semana en curso</div>
              </div>
              <div @click="reporteTipo = 'MENSUAL'; actualizarAsuntoReporte()" style="flex:1;padding:10px;text-align:center;border-radius:8px;cursor:pointer;font-size:12px;font-weight:600" :style="reporteTipo === 'MENSUAL' ? {border:'2px solid #2d5f8a',background:'rgba(45,95,138,0.05)',color:'#1a2744'} : {border:'1px solid #ddd',color:'#64748b'}">
                <div>Mensual</div><div style="font-size:10px;font-weight:400;margin-top:2px">Mes completo</div>
              </div>
            </div>
          </f7-block>
          <f7-block-title>Destinatarios</f7-block-title>
          <f7-block strong>
            <div style="margin-bottom:8px">
              <label style="font-size:11px;font-weight:600;color:#64748b;display:block;margin-bottom:4px">Para (separados por coma):</label>
              <textarea v-model="reporteEmails" rows="2" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px;resize:vertical;box-sizing:border-box" placeholder="email1@empresa.com, email2@empresa.com"></textarea>
            </div>
            <div style="margin-bottom:8px">
              <label style="font-size:11px;font-weight:600;color:#64748b;display:block;margin-bottom:4px">CC (opcional):</label>
              <input v-model="reporteCc" type="text" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px;box-sizing:border-box" placeholder="cc@empresa.com">
            </div>
          </f7-block>
          <f7-block-title>Asunto</f7-block-title>
          <f7-block strong>
            <input v-model="reporteAsunto" type="text" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px;box-sizing:border-box">
          </f7-block>
          <!-- Desde la #15 el envio recalcula los datos antes de generar el correo, asi que puede
               tardar hasta un minuto. Se dice en el boton: si solo pusiera "Enviando..." pareceria
               colgado y quien lo mira acabaria volviendo a pulsar. -->
          <f7-block>
            <f7-button fill color="green" @click="confirmarEnvioReporte" :disabled="enviandoReporte">
              {{ enviandoReporte ? 'Recalculando y enviando...' : 'Enviar informe' }}
            </f7-button>
          </f7-block>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
/* Popup persona */
.popup-persona { --f7-popup-tablet-width: 480px; }
.popup-reporte { --f7-popup-tablet-width: 500px; }

/* Zoom container */
.contenido-oea { font-size: 10px; }

/* Selector de mes */
.mes-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8em;
  padding: 0.3em 0.6em 0.2em;
}
.select-anio, .select-mes { font-size: 1.2em; font-weight: 600; padding: 0.2em 0.4em; border: 1px solid #ddd; border-radius: 0.3em; background: white; color: #1a2744; text-align: center; }
.select-anio { min-width: 5em; }
.select-mes { min-width: 8em; }
.mes-badge {
  display: inline-block;
  font-size: 0.7em;
  padding: 0.2em 0.8em;
  border-radius: 2em;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.badge-activo { background: #E8F5E9; color: #2E7D32; }
.badge-cerrado { background: #ECEFF1; color: #546E7A; }
.badge-borrador { background: #FFF3E0; color: #E65100; }

/* Métricas */
.metricas-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.4em;
  padding: 0 0.6em 0.3em;
}
@media (max-width: 600px) {
  .metricas-grid { grid-template-columns: repeat(2, 1fr); }
}
.metrica-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafe 100%);
  border: 1px solid #e8edf3;
  border-radius: 0.5em;
  padding: 0.4em 0.6em;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}
.metrica-label {
  font-size: 0.65em;
  color: #7c8db0;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 600;
  margin-bottom: 0.1em;
}
.metrica-valor { font-size: 1.2em; font-weight: 700; color: #1a2744; letter-spacing: -0.02em; }

/* Indicadores (#40) — mismos valores que en control-cifras-oeb.vue, con 8 columnas en vez de 11
   porque aquí no van las tres tarjetas de producción. Se copian y no se comparten porque los
   estilos de estas pantallas son scoped y cada una lleva los suyos. */
.indicadores-grid { display:grid; grid-template-columns:repeat(8,1fr); gap:0.4em; padding:0.3em 0.6em; }
@media (max-width:900px) { .indicadores-grid { grid-template-columns:repeat(4,1fr); } }
@media (max-width:500px) { .indicadores-grid { grid-template-columns:repeat(2,1fr); } }
.ind-card { border-radius:0.5em; padding:0.35em 0.5em; text-align:center; }
.ind-label { font-size:10px; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; opacity:0.7; margin-bottom:0.1em; }
.ind-val { font-size:16px; font-weight:500; }
.ind-gris { background:#f0f4fa; color:#1a2744; }
.ind-amarillo { background:#FFF9E6; color:#856404; }
.ind-rojo { background:#FEE2E2; color:#991B1B; }
.ind-azul { background:#E6F1FB; color:#0C447C; }

/* Info actualización */
.info-actualizacion { padding: 0 0.6em 0.2em; font-size: 0.65em; color: #9aa5b8; letter-spacing: 0.02em; }

/* Botones acción */
.acciones-bar { display: flex; gap: 0.4em; padding: 0 0.6em 0.3em; flex-wrap: wrap; }
.acciones-bar .button { font-size: 0.75em; font-weight: 600; letter-spacing: 0.03em; border-radius: 0.5em; padding: 0.3em 0.8em; }

/* Tabla principal — Executive Dashboard */
.tabla-container { padding: 0 0.4em; }
.tabla-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #dde3ed;
  border-radius: 0.8em;
  margin: 0 0.6em;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  background: white;
}
.tabla-oea { border-collapse: collapse; font-size: 1em; white-space: nowrap; width: 100%; }
.tabla-oea thead th {
  background: #1a2744;
  color: #c8d3e5;
  padding: 0.5em 0.4em;
  font-weight: 600;
  font-size: 0.85em;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: none;
  text-align: right;
  position: sticky;
  top: 0;
  z-index: 2;
}
.tabla-oea thead th.col-codigo { text-align: left; color: white; }
.tabla-oea tbody tr { transition: background 0.15s; }
.tabla-oea tbody tr:nth-child(even) { background: #fafbfd; }
.tabla-oea tbody tr:hover { background: #eef2f9 !important; }
.tabla-oea tbody td {
  padding: 0.35em 0.4em;
  border-bottom: 1px solid #eef0f5;
  text-align: right;
  font-size: 0.95em;
  color: #2d3748;
}
.tabla-oea tbody td.col-codigo { text-align: left; font-weight: 700; color: #1a2744; letter-spacing: 0.02em; min-width: 5em; }

/* Sticky column */
.col-sticky { position: sticky; left: 0; background: white; z-index: 1; box-shadow: 2px 0 8px rgba(0,0,0,0.06); }
thead .col-sticky { background: #1a2744; z-index: 3; }
.fila-totales .col-sticky, .fila-obj-sem .col-sticky, .fila-dif-sem .col-sticky, .fila-pct-sem .col-sticky { background: #eef1f7; }

/* Column types */
.col-sem { min-width: 4.8em; }
.col-num { min-width: 5em; }
.col-dia { min-width: 2em; text-align: center !important; font-size: 0.85em; color: #7c8db0; }
.col-pct { min-width: 4.5em; text-align: center !important; }
.col-progresion { font-weight: 700; min-width: 5.5em; }

/* Separators */
.col-sep-left { border-left: 2px solid #c8d0de !important; }
thead .col-sep-left { border-left: 2px solid #3d5278 !important; }

/* Special states */
.dia-modificado { background: #fff3cd !important; font-weight: bold; }
.fila-persona { cursor: pointer; }
.sem-fechas { font-size: 0.8em; color: #7c8db0; }

/* Filas closer: informativas, nunca suman a totales */
.fila-closer td { font-style: italic; background: #f7f2fb; color: #6f42c1; }
.fila-closer .col-sticky { background: #f7f2fb; }
.badge-closer { display: inline-block; background: #6f42c1; color: #fff; border-radius: 3px; padding: 0 4px; font-size: 0.7em; font-style: normal; font-weight: 700; letter-spacing: 0.5px; vertical-align: middle; }

/* Footer rows */
.fila-totales td { background: #eef1f7; font-weight: 700; padding: 0.45em 0.4em; border-top: 2px solid #c8d0de; color: #1a2744; font-size: 1em; }
.fila-obj-sem td { background: #f5f7fa; font-size: 0.85em; color: #7c8db0; padding: 0.25em 0.4em; font-weight: 500; }
.fila-dif-sem td { font-size: 0.85em; padding: 0.25em 0.4em; font-weight: 500; }
.fila-pct-sem td { font-size: 0.85em; padding: 0.25em 0.4em; border-bottom: 2px solid #c8d0de; }

/* Badges clasificación */
.badge-cls {
  display: inline-block;
  padding: 0.1em 0.6em;
  border-radius: 0.4em;
  font-weight: 700;
  font-size: 0.85em;
  letter-spacing: 0.03em;
}
.badge-GC { background: #FFF3E0; color: #E65100; border: 1px solid #FFCC80; }
.badge-FV { background: #E3F2FD; color: #1565C0; border: 1px solid #90CAF9; }
.badge-IC { background: #EDE7F6; color: #4527A0; border: 1px solid #B39DDB; }

/* Badges estado */
.badge-estado {
  display: inline-block;
  padding: 0.15em 0.6em;
  border-radius: 2em;
  font-weight: 700;
  font-size: 0.85em;
  letter-spacing: 0.02em;
}
.estado-MUY_BUENO { background: #D6EAF8; color: #1B4F72; }
.estado-BUENO { background: #D5F5E3; color: #0E6251; }
.estado-MALO { background: #FADBD8; color: #943126; }
.estado-MUY_MALO { background: #F1948A; color: #641E16; }

/* Colores métricas */
.color-MUY_BUENO { color: #1B4F72; }
.color-BUENO { color: #0E6251; }
.color-MALO { color: #943126; }
.color-MUY_MALO { color: #B71C1C; }

/* Valores */
.valor-positivo { color: #0E6251 !important; font-weight: 600; }
.valor-negativo { color: #B71C1C !important; font-weight: 600; }

/* Leyenda */
.leyenda { padding: 0.6em 0.8em; display: flex; gap: 1.2em; flex-wrap: wrap; font-size: 0.8em; color: #7c8db0; }
.leyenda-item { display: flex; align-items: center; gap: 0.4em; }
.dot { display: inline-block; width: 1em; height: 1em; border-radius: 50%; }
.dot.estado-MUY_BUENO { background: #D6EAF8; border: 1px solid #1B4F72; }
.dot.estado-BUENO { background: #D5F5E3; border: 1px solid #0E6251; }
.dot.estado-MALO { background: #FADBD8; border: 1px solid #943126; }
.dot.estado-MUY_MALO { background: #F1948A; border: 1px solid #641E16; }

/* Tabla resumen por clasificación */
.resumen-clasificacion { padding: 1.2em 0.8em; }
.tabla-resumen-cls {
  width: 100%;
  max-width: 650px;
  border-collapse: collapse;
  font-size: 1em;
  border: 1px solid #dde3ed;
  border-radius: 0.8em;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}
.tabla-resumen-cls thead tr { background: #1a2744; }
.tabla-resumen-cls th {
  padding: 0.6em 0.8em;
  text-align: right;
  font-weight: 600;
  font-size: 0.85em;
  color: #c8d3e5;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.tabla-resumen-cls th:first-child { text-align: left; }
.tabla-resumen-cls td { padding: 0.6em 0.8em; text-align: right; border-bottom: 1px solid #eef0f5; font-size: 0.95em; }
.tabla-resumen-cls td:first-child { text-align: left; }
.tabla-resumen-cls .fila-totales td { background: #eef1f7; font-weight: 700; border-top: 2px solid #c8d0de; }

/* Tabla historial */
.tabla-historial { width: 100%; border-collapse: collapse; font-size: 1.1em; }
.tabla-historial th { padding: 0.4em 0.6em; background: #f5f5f5; text-align: left; font-weight: 500; font-size: 1em; color: #7c8db0; border-bottom: 1px solid #ddd; }
.tabla-historial td { padding: 0.4em 0.6em; border-bottom: 1px solid #f0f0f0; font-size: 1em; }

/* Botón info + Popup guía */
.btn-info { width:24px;height:24px;border-radius:50%;background:rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;cursor:pointer;border:1.5px solid #5DCAA5; }
.btn-info span { color:#5DCAA5;font-size:13px;font-weight:500;font-style:italic; }
.btn-info-activo { background:#5DCAA5 !important; }
.btn-info-activo span { color:#1a2744 !important; }
.ct-popup-guia { --f7-popup-tablet-width:700px; }
.ct-hdr { padding:14px 16px 12px;flex-shrink:0; }
.ct-hdr-top { display:flex;justify-content:space-between;align-items:center;margin-bottom:12px; }
.ct-hdr-left { display:flex;align-items:center;gap:10px; }
.ct-hdr-ico { font-size:24px; }
.ct-hdr-title { font-size:16px;font-weight:800;color:#fff; }
.ct-hdr-sub { font-size:10px;color:rgba(255,255,255,.6);margin-top:1px; }
.ct-hdr-right { display:flex;align-items:center;gap:6px; }
.ct-hdr-badge { background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff; }
.ct-hdr-add,.ct-hdr-close { width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center; }
.ct-hdr-add:hover,.ct-hdr-close:hover { background:rgba(255,255,255,.25); }
.ct-search-wrap { position:relative;display:flex;align-items:center; }
.ct-search-ico { position:absolute;left:10px;font-size:13px; }
.ct-search { width:100%;padding:9px 32px;border:none;border-radius:8px;font-size:13px;background:rgba(255,255,255,.9);color:#1e293b;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.1); }
.ct-search:focus { background:#fff; }
.ct-search-x { position:absolute;right:8px;background:none;border:none;color:#94a3b8;font-size:12px;cursor:pointer;padding:4px; }
.ct-body { background:linear-gradient(180deg,#f8fafc,#f0f2f5);padding:10px 14px !important; }
.ct-counter { font-size:11px;color:#64748b;font-weight:600;padding:4px 2px 8px; }
.ct-empty { text-align:center;padding:40px 20px;color:#94a3b8;font-size:12px; }
.ct-card { background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.05);overflow:hidden;cursor:grab; }
.ct-card:hover { box-shadow:0 3px 10px rgba(0,0,0,.08); }
.ct-card-hdr { display:flex;align-items:center;gap:10px;padding:10px 12px;cursor:pointer; }
.ct-card-num { width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;color:#fff;flex-shrink:0; }
.ct-card-title-area { flex:1;min-width:0; }
.ct-card-title { font-size:13px;font-weight:600;color:#1e293b;line-height:1.4; }
.ct-card-chev { font-size:10px;color:#94a3b8;flex-shrink:0; }
.ct-card-body { padding:0 12px 12px;border-top:1px solid #f1f5f9; }
.ct-card-content { font-size:12.5px;line-height:1.6;color:#334155;padding:10px 4px; }
.ct-card-actions { display:flex;gap:4px;padding-top:8px;border-top:1px solid #f1f5f9; }
.ct-card-actions button { background:none;border:1px solid #e2e8f0;border-radius:6px;padding:4px 10px;font-size:10px;cursor:pointer;color:#475569; }
.ct-card-actions button:hover { background:#f1f5f9; }
.ct-form-field { display:flex;flex-direction:column;gap:3px;margin-bottom:8px; }
.ct-form-field label { font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase; }
.ct-form-field input,.ct-form-field textarea { padding:8px 10px;border:1.5px solid #d1d9e0;border-radius:6px;font-size:12px;font-family:inherit;color:#1e293b;outline:none;resize:vertical; }
.ct-form-field input:focus,.ct-form-field textarea:focus { border-color:#0F6E56; }
.ct-form-btns { display:flex;gap:6px; }
.ct-fbtn { padding:7px 16px;border:none;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit; }
.ct-fbtn-ok { background:#0F6E56;color:#fff; }
.ct-fbtn-ok:hover { background:#0a4f42; }
.ct-fbtn-cancel { background:#f1f5f9;color:#475569;border:1px solid #e2e8f0; }
.ct-fbtn-cancel:hover { background:#e2e8f0; }
</style>
<style>
.popup-persona .navbar .left { display: none !important; }
.popup-persona .navbar .left a { display: none !important; }
.popup-persona .navbar .title-large { display: none !important; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
/* #26 · Con alto reservado: el sello se oculta mientras carga y sin esto la pantalla daba un salto
   cada vez que se cambiaba de mes. */
.sello-datos-bar { padding: 6px 16px 0; min-height: 30px; display: flex; flex-wrap: wrap; gap: 8px; }
</style>
<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import avisoNoGuardado from '../../js/utils/avisoNoGuardado.js';
import Oea from '../../js/db/Oea.js';
import InfoIcon from '../../components/InfoIcon.vue';
import SelloDatos from '../../components/SelloDatos.vue';
import carrilPeticiones from '../../js/utils/carrilPeticiones.js';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';

export default {
  components: { InfoIcon, SelloDatos },
  // #769 · La ficha del mes, las acciones que la recargan y su «cargando» van por el carril común
  // de la #472, como en las pantallas OEB: tira el mes de antes en cuanto se pide otro —antes se
  // quedaba debajo del selector nuevo hasta que contestaba el servidor— y solo apaga el «cargando»
  // la respuesta vigente. Recargar el MISMO mes no vacía: sería un parpadeo.
  created() {
    const self = this;
    self.carrilFicha = carrilPeticiones({
      deAhora: function() { return [self.anio, self.mes]; },
      vaciar: function() { self.vaciarFicha(); },
      cargando: function(si) { self.cargando = si; }
    });
  },
  // Lo que conteste ya no tiene a quién avisar si nadie está mirando la pantalla.
  beforeDestroy() {
    this.carrilFicha.invalidar();
  },
  data() {
    return {
      anio: new Date().getFullYear(),
      mes: new Date().getMonth() + 1,
      ficha: null,
      cargando: false,
      zoom: 100,
      historialConfig: [],
      ausencias: {},
      desglose: {},
      // #40 · codigoPersonal → horas de trabajo al día del ejercicio del mes en pantalla, tal
      // como las resuelve el backend. Solo alimenta las dos tarjetas de horas; la tabla no las usa.
      horasDiarias: {},
      closers: [],
      mostrarClosers: false,
      personaSel: null,
      popupAbierto: false,
      guardandoPersonas: false,
      objetivoEditable: 0,
      vacacionesEditable: 0,
      popupReporte: false,
      reporteTipo: 'MENSUAL',
      reporteEmails: '',
      reporteCc: '',
      reporteAsunto: '',
      enviandoReporte: false,
      popupInfo: false,
      fullscreen: false,
      instrucciones: [],
      busquedaInst: '',
      expandedInst: null,
      draggingInst: null,
    };
  },
  computed: {
    instFiltradas() {
      var q = (this.busquedaInst || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) { return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1; });
    },
    nombresMeses() {
      return ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    },
    aniosDisponibles() {
      var arr = [];
      for (var a = 2007; a <= new Date().getFullYear() + 1; a++) arr.push(a);
      return arr;
    },
    nombreMes() {
      var meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      return meses[this.mes] || '';
    },
    nombreMesSiguiente() {
      var m = this.mes === 12 ? 1 : this.mes + 1;
      var a = this.mes === 12 ? this.anio + 1 : this.anio;
      var meses = ['','Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      return meses[m] + ' ' + a;
    },
    personasOrdenadas() {
      if (!this.ficha || !this.ficha.personas) return [];
      var orden = { 'GC': 1, 'FV': 2, 'I/C': 3 };
      return [...this.ficha.personas].sort(function(a, b) {
        var oa = orden[a.clasificacion] || 4;
        var ob = orden[b.clasificacion] || 4;
        if (oa !== ob) return oa - ob;
        return a.codigoPersonal.localeCompare(b.codigoPersonal);
      });
    },
    // Fila TOTAL, bloque de días: se suma sobre personasOrdenadas —las filas que se están
    // pintando— para que el total refleje lo que se ve si hay filtros. Las CLOSER quedan fuera,
    // como en el resto de totales de la pantalla.
    totalesDias() {
      var self = this;
      var t = { diasHabiles: 0, vacaciones: 0, bajas: 0, fiestas: 0, compensacion: 0, diasReales: 0 };
      this.personasOrdenadas.forEach(function(p) {
        t.diasHabiles += self.calcularDiasHabilesPersona(p) || 0;
        t.vacaciones += self.vacPersona(p) || 0;
        t.bajas += self.blPersona(p) || 0;
        t.fiestas += self.fiestasPersona(p) || 0;
        t.compensacion += self.compPersona(p) || 0;
        t.diasReales += p.diasReales || 0;
      });
      // COMP va en horas y admite decimal: mismo redondeo que las celdas de arriba
      t.compensacion = Math.round(t.compensacion * 10) / 10;
      return t;
    },
    // Días por semana del bloque de días: cuadran por posición, igual que el tbody, y respetan
    // el mismo fallback de diasReales a diasHabiles.
    totalesDiasSemana() {
      if (!this.ficha || !this.ficha.calendario || !this.ficha.calendario.semanas) return [];
      var personas = this.personasOrdenadas;
      return this.ficha.calendario.semanas.map(function(sem, idx) {
        return personas.reduce(function(sum, p) {
          var s = p.semanas ? p.semanas[idx] : null;
          if (!s) return sum;
          return sum + (s.diasReales != null ? s.diasReales : (s.diasHabiles || 0));
        }, 0);
      });
    },
    // #40 · Horas del mes sin redondear: por cada persona de la pantalla, sus días reales por sus
    // horas al día; después se suman. Misma fórmula que en OEB. Sobre personasOrdenadas, como
    // el resto de totales, para que quitar a alguien del mes baje también esta tarjeta.
    // Es la base de las dos tarjetas de horas, y por eso conserva el decimal: media jornada da
    // medias horas (7,5 h × 21 días = 157,5) y dividir por 158 desplazaría la productividad.
    totalHorasMes() {
      var self = this;
      var total = 0;
      this.personasOrdenadas.forEach(function(p) {
        total += self.getHorasDiarias(p.codigoPersonal) * (p.diasReales || 0);
      });
      return total;
    },
    // #40 · Tarjeta Nº HORAS MES: el redondeo es solo de presentación, igual que en OEB.
    indTotalHorasMes() {
      return Math.round(this.totalHorasMes);
    },
    // #40 · Tarjeta PRODUCTIVIDAD VENTAS: euros contratados por hora trabajada. "Ventas" es lo
    // conseguido (progresión total), no el objetivo. Sin horas se queda vacía: un 0 aquí se
    // leería como productividad nula y lo que pasa es que no se puede calcular.
    indProductividadVentas() {
      if (!this.ficha || !this.ficha.totales || this.totalHorasMes <= 0) return '—';
      var valor = (this.ficha.totales.progresionTotal || 0) / this.totalHorasMes;
      return valor.toFixed(1).replace('.', ',') + ' €/h';
    },
    resumenPorClasificacion() {
      if (!this.ficha || !this.ficha.personas) return [];
      var grupos = {};
      var totalProgresion = this.ficha.totales ? this.ficha.totales.progresionTotal : 0;
      this.ficha.personas.forEach(function(p) {
        var cls = p.clasificacion || 'I/C';
        if (!grupos[cls]) {
          grupos[cls] = { clasificacion: cls, totalResultado: 0, totalObjetivo: 0 };
        }
        grupos[cls].totalResultado += (p.progresionMes || 0);
        grupos[cls].totalObjetivo += (p.objetivoMensual || 0);
      });
      var orden = ['GC', 'FV', 'I/C'];
      return orden.map(function(cls) {
        var g = grupos[cls] || { clasificacion: cls, totalResultado: 0, totalObjetivo: 0 };
        g.diferencia = g.totalResultado - g.totalObjetivo;
        g.porcentaje = g.totalObjetivo > 0 ? (g.totalResultado / g.totalObjetivo) * 100 : 0;
        g.porcentajeTotal = totalProgresion > 0 ? Math.round(g.totalResultado / totalProgresion * 100) : 0;
        return g;
      }).filter(function(g) { return g.totalResultado > 0 || g.totalObjetivo > 0; });
    },
    historialPersona() {
      var cambios = [];
      if (this.personaSel && this.personaSel.semanas) {
        this.personaSel.semanas.forEach(function(sem) {
          if (sem.modificado && sem.modificacion) {
            cambios.push({
              fecha: sem.modificacion.fecha,
              campo: 'Días S' + sem.semanaNumero,
              valorAnterior: sem.modificacion.diasAnterior + ' días',
              valorNuevo: sem.modificacion.diasNuevo + ' días',
              usuario: sem.modificacion.usuario,
              motivo: sem.modificacion.motivo
            });
          }
        });
      }
      if (this.historialConfig && this.historialConfig.length > 0) {
        this.historialConfig.forEach(function(c) { cambios.push(c); });
      }
      cambios.sort(function(a, b) { return new Date(b.fecha) - new Date(a.fecha); });
      return cambios;
    }
  },
  methods: {
    // Columnas Vac / BL / FIES / COMP: leen del desglose de ausencias que ya envía el backend
    vacPersona(persona) {
      var d = this.desglose[persona.codigoPersonal];
      if (!d || !d.vacsSem) return 0;
      return d.vacsSem.reduce(function(a, b) { return a + (b || 0); }, 0);
    },
    blPersona(persona) {
      var d = this.desglose[persona.codigoPersonal];
      return d && d.diasBajaLaboral ? d.diasBajaLaboral : 0;
    },
    fiestasPersona(persona) {
      var d = this.desglose[persona.codigoPersonal];
      if (!d || !d.fiestasSem) return 0;
      return d.fiestasSem.reduce(function(a, b) { return a + (b || 0); }, 0);
    },
    compPersona(persona) {
      var d = this.desglose[persona.codigoPersonal];
      return d && d.compTotal ? Math.round(d.compTotal * 10) / 10 : 0;
    },
    // #40 · El backend ya manda el mapa relleno para todas las personas del mes; las 8 h de aquí
    // son el último cortafuegos, para una persona que apareciera en pantalla sin venir en él.
    getHorasDiarias(cod) {
      if (this.horasDiarias && this.horasDiarias[cod] != null) return this.horasDiarias[cod];
      return 8;
    },
    zoomIn() { this.zoom = Math.min(150, this.zoom + 5); },
    zoomOut() { this.zoom = Math.max(40, this.zoom - 5); },
    onPageInit() {
      var guardadoAnio = localStorage.getItem('oea_ultimo_anio');
      var guardadoMes = localStorage.getItem('oea_ultimo_mes');
      if (guardadoAnio) this.anio = parseInt(guardadoAnio);
      if (guardadoMes) this.mes = parseInt(guardadoMes);
      this.cargarFicha();
      this.cargarInstrucciones();
    },
    cargarFicha() {
      localStorage.setItem('oea_ultimo_anio', this.anio);
      localStorage.setItem('oea_ultimo_mes', this.mes);
      const self = this;
      self.carrilFicha.lanzar(Oea.getFichaControlCifras(self.anio, self.mes), {
        exito: function(res) {
          const data = unwrapDto(res) || {};
          self.ficha = data.ficha || null;
          self.ausencias = data.ausencias || {};
          self.desglose = data.desglose || {};
          self.horasDiarias = data.horasDiarias || {};
          self.closers = data.closers || [];
        },
        limpiar: function() { self.vaciarFicha(); }
      });
    },
    // Lo que se tira al cambiar de mes y al fallar la carga: un solo sitio para los dos.
    vaciarFicha() {
      this.ficha = null;
      this.ausencias = {};
      this.desglose = {};
      this.horasDiarias = {};
      this.closers = [];
    },
    mesPrevio() {
      if (this.mes === 1) { this.mes = 12; this.anio--; }
      else { this.mes--; }
      this.cargarFicha();
    },
    mesSiguiente() {
      if (this.mes === 12) { this.mes = 1; this.anio++; }
      else { this.mes++; }
      this.cargarFicha();
    },
    actualizarCifras() {
      const self = this;
      if (!self.ficha) return;
      // #164 · El refresco entra por el mismo carril que la carga: si mientras está en vuelo se
      // cambia de mes, manda la carga nueva y este final ya no toca la pantalla.
      const nombre = self.nombreMes + ' ' + self.anio;
      // #164 · Sin esto el reloj se quedaba girando sin fin y sin decir nada. No se pinta aviso de
      // carga: la ficha que se está viendo sigue siendo válida, lo que no ha ido es el refresco.
      //
      // El aviso sale AUNQUE se haya cambiado de mes por el camino: lo que ha fallado es una
      // escritura que el usuario pidió, y callársela porque esta operación ya no manda es el fallo
      // silencioso que esta tarea viene a quitar. Por eso lleva el mes dentro —se puede leer con
      // otro mes delante— y sale también por `descartada`; el reloj sí es de quien manda, y lo
      // lleva el carril (#769).
      const avisarFallo = function() {
        self.$f7.toast.create({ text: 'No se han podido actualizar las cifras de ' + nombre + '. Vuelve a intentarlo.', position: 'top', closeTimeout: 4000 }).open();
      };
      self.carrilFicha.lanzar(Oea.actualizarCifras(self.anio, self.mes), {
        exito: function() { self.cargarFicha(); },
        fallo: avisarFallo,
        descartada: function(ok) { if (!ok) avisarFallo(); }
      });
    },
    crearFichaMes() {
      const self = this;
      // El mes se fija al empezar: son tres peticiones encadenadas y el selector se puede mover por
      // el camino, así que leyendo `self.anio`/`self.mes` en cada paso se acababa recalculando y
      // actualizando un mes distinto del que se acaba de crear.
      const anio = self.anio;
      const mes = self.mes;
      const nombre = self.nombreMes + ' ' + anio;
      // #769 · La ficha recién creada ya no se pinta a mitad de la cadena, con el recálculo todavía
      // en vuelo: se escribía por fuera del carril, que entonces no sabía que había algo que tirar,
      // y un cambio de mes en ese rato la dejaba debajo del selector nuevo. Se pinta al final, con
      // la recarga, que trae ya las cifras calculadas. Igual que en OEB.
      let creada = false;
      const creacion = Oea.crearFicha(anio, mes).then(function() {
        creada = true;
        return Oea.recalcularFicha(anio, mes);
      }).then(function() {
        return Oea.actualizarCifras(anio, mes);
      });
      // #164 · El fallo se avisa siempre; lo que depende de seguir mandando es si además se
      // puede tocar la pantalla. Ver `avisarCreacionFallida`.
      self.carrilFicha.lanzar(creacion, {
        exito: function() {
          self.$f7.toast.create({ text: 'Ficha de ' + nombre + ' creada y actualizada', position: 'top', closeTimeout: 2000 }).open();
          self.cargarFicha();
        },
        fallo: function(err) { self.avisarCreacionFallida(err, creada, anio, mes, nombre, true); },
        descartada: function(ok, err) {
          if (!ok) self.avisarCreacionFallida(err, creada, anio, mes, nombre, false);
        }
      });
    },
    // #164 · Las tres peticiones de la creación caen en el mismo `catch`, pero solo la primera
    // decide si el mes existe: si `crearFicha` ya respondió bien, el servidor conserva la ficha
    // aunque falle el cálculo, y decir «no se ha creado» invita a crearlo otra vez y a llevarse el
    // error de duplicado. Cuando la creación se confirmó —o se cortó sin respuesta, y entonces no se
    // sabe— se lleva el selector a ese mes y se recarga, que es lo único que enseña si está o no:
    // sin eso el diálogo pedía abrirla y detrás seguía habiendo solo el botón «Crear ficha», o sea
    // el camino al duplicado. El reloj no se toca aquí (#769): lo apaga el carril cuando no queda
    // nada en vuelo, y si este final recarga, la recarga lo mantiene puesto. Mismo criterio que en
    // Control de cifras OEB — Planificación.
    //
    // `manda` es si la operación sigue siendo la dueña de la pantalla. Si el usuario cambió de mes
    // mientras la creación viajaba, ya no lo es: el aviso SALE IGUAL —el mes quedó a medias en el
    // servidor y callarlo es justo lo que lleva al duplicado— pero no se le secuestra el selector
    // ni se le pisa la carga que acaba de arrancar, así que el texto le dice que entre él al mes
    // en vez de prometerle que se abre solo.
    avisarCreacionFallida(err, creada, anio, mes, nombre, manda) {
      if (!creada && !Oea.esResultadoIncierto(err)) {
        this.$f7.dialog.alert('No se ha podido crear la ficha de ' + nombre + '. Vuelve a intentarlo.', 'No se ha creado el mes');
        return;
      }
      if (!manda) {
        this.$f7.dialog.alert(creada
          ? 'La ficha de ' + nombre + ' sí se ha creado, pero no se han podido calcular sus cifras. Entra en ese mes y usa «Actualizar cifras» para terminarla: no la crees otra vez.'
          : 'No se ha podido saber si la ficha de ' + nombre + ' llegó a crearse. Entra en ese mes para comprobarlo: si ya está, no la crees otra vez.',
          creada ? 'El mes se ha creado sin cifras' : 'Puede que el mes se haya creado');
        return;
      }
      this.anio = anio;
      this.mes = mes;
      this.$f7.dialog.alert(creada
        ? 'La ficha de ' + nombre + ' sí se ha creado, pero no se han podido calcular sus cifras. Se abre a continuación: no la crees otra vez, usa «Actualizar cifras» para terminarla.'
        : 'No se ha podido saber si la ficha de ' + nombre + ' llegó a crearse. Se abre a continuación para que lo compruebes: si ya está, no la crees otra vez.',
        creada ? 'El mes se ha creado sin cifras' : 'Puede que el mes se haya creado');
      this.cargarFicha();
    },
    crearMesSiguiente() {
      const self = this;
      const mesNuevo = self.mes === 12 ? 1 : self.mes + 1;
      const anioNuevo = self.mes === 12 ? self.anio + 1 : self.anio;
      const meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      self.$f7.dialog.confirm('¿Crear ficha de ' + meses[mesNuevo] + ' ' + anioNuevo + '?', 'Crear mes', function() {
        let creada = false;
        const nombre = meses[mesNuevo] + ' ' + anioNuevo;
        const creacion = Oea.crearFicha(anioNuevo, mesNuevo).then(function() {
          creada = true;
          return Oea.recalcularFicha(anioNuevo, mesNuevo);
        }).then(function() {
          return Oea.actualizarCifras(anioNuevo, mesNuevo);
        });
        self.carrilFicha.lanzar(creacion, {
          exito: function() {
            self.mes = mesNuevo;
            self.anio = anioNuevo;
            self.$f7.toast.create({ text: 'Ficha de ' + nombre + ' creada', position: 'top', closeTimeout: 2000 }).open();
            self.cargarFicha();
          },
          fallo: function(err) { self.avisarCreacionFallida(err, creada, anioNuevo, mesNuevo, nombre, true); },
          descartada: function(ok, err) {
            if (!ok) self.avisarCreacionFallida(err, creada, anioNuevo, mesNuevo, nombre, false);
          }
        });
      });
    },
    getNombreMesSiguiente() {
      var m = this.mes === 12 ? 1 : this.mes + 1;
      var a = this.mes === 12 ? this.anio + 1 : this.anio;
      var meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      return meses[m] + ' ' + a;
    },
    // #34 · La persona tiene que existir ya en la Configuración OEA: desde aquí no se da de alta
    // a nadie. El desplegable ofrece solo a los que están en esa configuración y no están ya en
    // pantalla; antes ofrecía los del reparto y creaba la ficha de configuración por su cuenta.
    agregarPersona() {
      var self = this;
      Oea.getPersonasConfig()
        .then(function(res) {
          var personasConfig = unwrapDto(res) || [];
          var personasEnFicha = (self.ficha.personas || []).map(function(p) { return p.codigoPersonal; });
          var disponibles = personasConfig.filter(function(p) { return personasEnFicha.indexOf(p.codigoPersonal) === -1; });

          if (disponibles.length === 0) {
            self.$f7.dialog.alert('Todas las personas de la Configuración OEA ya están en esta pantalla. Para incorporar a alguien nuevo, primero hay que darle de alta en Configuración OEA.', 'Sin personas que añadir');
            return;
          }

          var buttons = disponibles.map(function(p) {
            return {
              text: p.codigoPersonal + (p.nombre && p.nombre !== p.codigoPersonal ? ' — ' + p.nombre : ''),
              onClick: function() { self.agregarPersonaCodigo(p.codigoPersonal); }
            };
          });

          self.$f7.actions.create({
            buttons: [
              [{ text: 'Personas de la Configuración OEA', label: true }].concat(buttons),
              [{ text: 'Cancelar' }]
            ]
          }).open();
        });
    },
    // Se recarga la ficha en vez de quedarse con la que devuelve el POST: la de la respuesta no
    // lleva el enriquecido (ausencias, días reales, objetivos) que pinta esta pantalla.
    agregarPersonaCodigo(codigo) {
      var self = this;
      Oea.agregarPersonaAFicha(self.ficha.id, codigo)
        .then(function(res) {
          if (unwrapDto(res)) { self.cargarFicha(); }
          else { self.$f7.dialog.alert(res.message || 'Error', 'Error'); }
        })
        .catch(function() {
          self.$f7.dialog.alert('No se ha podido añadir a ' + codigo + ' a este mes', 'Error');
        });
    },
    // #34 · Fija para este mes la lista de personas que hay ahora en pantalla. A partir de aquí
    // la ve cualquier usuario que abra la pantalla en este mes, y el mes siguiente la hereda al
    // crearse.
    guardarPersonasVisibles() {
      var self = this;
      if (!self.ficha || self.guardandoPersonas) return;
      var codigos = self.personasOrdenadas.map(function(p) { return p.codigoPersonal; });
      self.$f7.dialog.confirm(
        'Se fijan las ' + codigos.length + ' personas que se ven ahora para ' + self.nombreMes + ' ' + self.anio + '. Las verá así todo el mundo. ¿Guardar?',
        'Guardar personas del mes',
        function() {
          // #663 · El cerrojo atado a la sesión: si cambia en vuelo, la frontera calla el `then`
          // que lo soltaba, y la ruta conserva la instancia para la cuenta siguiente.
          cerrojoDeLaSesion(self, 'guardandoPersonas');
          Oea.guardarPersonasVisibles(self.ficha.id, codigos)
            .then(function() {
              self.guardandoPersonas = false;
              self.$f7.toast.create({ text: 'Personas de ' + self.nombreMes + ' guardadas', position: 'top', closeTimeout: 2000 }).open();
              self.cargarFicha();
            })
            .catch(function() {
              self.guardandoPersonas = false;
              self.$f7.dialog.alert('No se han podido guardar las personas del mes', 'Error');
            });
        });
    },
    irANotificaciones() {
      this.$f7router.navigate('/dashboard/oea/notificaciones/');
    },
    enviarReporte() {
      var self = this;
      var mesNombre = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      self.reporteAsunto = 'Informe OEA — SIMECAL — ' + mesNombre[self.mes] + ' ' + self.anio;
      // Precargar emails de personas OEA
      Oea.getPersonasConfig().then(function(res) {
        var personas = unwrapDto(res) || [];
        var emails = personas.filter(function(p) { return p.email && p.activo; }).map(function(p) { return p.email; });
        self.reporteEmails = emails.join(', ');
        self.popupReporte = true;
      }).catch(function() { self.popupReporte = true; });
    },
    actualizarAsuntoReporte() {
      var mesNombre = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      if (this.reporteTipo === 'DIARIO') this.reporteAsunto = 'Informe diario OEA — SIMECAL — ' + new Date().toLocaleDateString('es-ES');
      else if (this.reporteTipo === 'SEMANAL') this.reporteAsunto = 'Informe semanal OEA — SIMECAL';
      else this.reporteAsunto = 'Informe OEA — SIMECAL — ' + mesNombre[this.mes] + ' ' + this.anio;
    },
    confirmarEnvioReporte() {
      var self = this;
      var emails = self.reporteEmails.split(',').map(function(e) { return e.trim(); }).filter(function(e) { return e; });
      if (!emails.length) {
        self.$f7.toast.create({ text: 'Introduce al menos un email', position: 'top', closeTimeout: 2000 }).open();
        return;
      }
      var emailsCc = self.reporteCc ? self.reporteCc.split(',').map(function(e) { return e.trim(); }).filter(function(e) { return e; }) : [];
      cerrojoDeLaSesion(self, 'enviandoReporte');
      Oea.enviarReporte({
        anio: self.anio, mes: self.mes,
        emails: emails, emailsCc: emailsCc, emailsCco: [],
        asunto: self.reporteAsunto,
        tipoReporte: self.reporteTipo
      }).then(function(res) {
        self.enviandoReporte = false;
        self.popupReporte = false;
        self.$f7.toast.create({ text: unwrapDto(res) || 'Reporte enviado', position: 'top', closeTimeout: 3000 }).open();
      }).catch(function(e) {
        self.enviandoReporte = false;
        self.$f7.toast.create({ text: 'Error al enviar: ' + (e.message || 'desconocido'), position: 'top', closeTimeout: 3000 }).open();
      });
    },
    abrirDetallePersona(persona) {
      var self = this;
      self.personaSel = persona;
      self.objetivoEditable = persona.objetivoDiarioActual || 0;
      self.vacacionesEditable = persona.diasVacaciones || 0;
      self.historialConfig = [];
      self.popupAbierto = true;
      Oea.getPersona(persona.codigoPersonal).then(function(res) {
        if (unwrapDto(res) && unwrapDto(res).historicoCambios) {
          self.historialConfig = unwrapDto(res).historicoCambios || [];
        }
      }).catch(function() {});
    },
    guardarObjetivo(persona) {
      var self = this;
      Oea.cambiarObjetivoDiarioEnFicha(self.ficha.id, persona.codigoPersonal, {
        objetivoDiario: self.objetivoEditable
      }).then(function(res) {
        if (unwrapDto(res)) {
          self.ficha = unwrapDto(res);
          var actualizada = self.ficha.personas.find(function(p) { return p.codigoPersonal === persona.codigoPersonal; });
          if (actualizada) { self.personaSel = actualizada; self.objetivoEditable = actualizada.objetivoDiarioActual; }
          self.$f7.toast.create({ text: 'Objetivo actualizado', position: 'top', closeTimeout: 2000 }).open();
        }
      // #164 · Sin este aviso el usuario veía el valor nuevo en el popup y el viejo al recargar,
      // sin que nada dijera que no se había guardado.
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'el objetivo de ' + persona.codigoPersonal, err);
      });
    },
    editarDiaSemana(semana) {
      var self = this;
      var persona = self.personaSel;
      self.$f7.dialog.prompt('Nuevos días hábiles (S' + semana.semanaNumero + '):', 'Días hábiles',
        function(dias) {
          self.$f7.dialog.prompt('Motivo del cambio:', 'Motivo',
            function(motivo) {
              Oea.modificarDiasHabiles(self.ficha.id, persona.codigoPersonal, {
                semanaNumero: semana.semanaNumero,
                diasHabiles: parseInt(dias),
                motivo: motivo || 'Sin motivo'
              }).then(function(res) {
                if (unwrapDto(res)) {
                  self.ficha = unwrapDto(res);
                  var actualizada = self.ficha.personas.find(function(p) { return p.codigoPersonal === persona.codigoPersonal; });
                  if (actualizada) self.personaSel = actualizada;
                  self.$f7.toast.create({ text: 'Días actualizados', position: 'top', closeTimeout: 2000 }).open();
                }
              }).catch(function(err) {
                avisoNoGuardado(self.$f7, 'los días hábiles de ' + persona.codigoPersonal, err);
              });
            }, function() {}, 'Cambio de días'
          );
        }, function() {}, semana.diasHabiles + ''
      );
    },
    verNotaDias(semana) {
      if (semana.modificacion) {
        this.$f7.dialog.alert('De ' + semana.modificacion.diasAnterior + ' a ' + semana.modificacion.diasNuevo + ' días\nMotivo: ' + semana.modificacion.motivo + '\nPor: ' + semana.modificacion.usuario + '\nFecha: ' + (semana.modificacion.fecha ? new Date(semana.modificacion.fecha).toLocaleDateString('es-ES') : ''), 'Nota de modificación');
      }
    },
    obtenerRangoSemana(semanaNumero) {
      if (!this.ficha || !this.ficha.calendario) return '';
      var sem = this.ficha.calendario.semanas.find(function(s) { return s.numero === semanaNumero; });
      if (!sem) return '';
      var match = sem.etiqueta.match(/\((\d+-\d+)\)/);
      return match ? match[1] : '';
    },
    calcularObjMensual() {
      if (!this.personaSel || !this.personaSel.semanas) return 0;
      var obj = this.objetivoEditable || 0;
      return this.personaSel.semanas.reduce(function(sum, s) { return sum + (obj * (s.diasReales != null ? s.diasReales : (s.diasHabiles || 0))); }, 0);
    },
    dsg(campo, idx) {
      var d = this.desglose[this.personaSel.codigoPersonal];
      if (!d || !d[campo] || d[campo][idx] == null) return 0;
      return d[campo][idx];
    },
    totalOrig() {
      if (!this.personaSel || !this.personaSel.semanas) return 0;
      return this.personaSel.semanas.reduce(function(s, x) { return s + (x.diasHabilesOriginal || 0); }, 0);
    },
    totalDsg(campo) {
      var d = this.desglose[this.personaSel.codigoPersonal];
      if (!d || !d[campo]) return 0;
      return d[campo].reduce(function(s, v) { return s + (v || 0); }, 0);
    },
    compTotalPersona() {
      var d = this.desglose[this.personaSel.codigoPersonal];
      return (d && d.compTotal != null) ? d.compTotal : 0;
    },
    guardarClasificacion(persona, nueva) {
      var self = this;
      Oea.cambiarClasificacionEnFicha(self.ficha.id, persona.codigoPersonal, {
        clasificacion: nueva
      }).then(function(res) {
        if (unwrapDto(res)) {
          self.ficha = unwrapDto(res);
          var actualizada = self.ficha.personas.find(function(p) { return p.codigoPersonal === persona.codigoPersonal; });
          if (actualizada) self.personaSel = actualizada;
          self.$f7.toast.create({ text: 'Clasificación actualizada', position: 'top', closeTimeout: 2000 }).open();
        }
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'la clasificación de ' + persona.codigoPersonal, err);
      });
    },
    // #34 · Quitar deja de enseñarla; sus cifras del mes se quedan donde estaban y vuelven si se
    // la añade otra vez. El popup de la persona se cierra: la que tenía abierta ya no está.
    quitarPersona(persona) {
      var self = this;
      self.$f7.dialog.confirm('¿Quitar a ' + persona.codigoPersonal + ' de este mes? Deja de verse, pero sus cifras no se borran: si se la vuelve a añadir, siguen ahí.', 'Confirmar', function() {
        Oea.quitarPersonaDeFicha(self.ficha.id, persona.codigoPersonal).then(function(res) {
          if (unwrapDto(res)) {
            self.popupAbierto = false;
            self.cargarFicha();
          }
        }).catch(function(err) {
          avisoNoGuardado(self.$f7, 'que ' + persona.codigoPersonal + ' deje de verse este mes', err);
        });
      });
    },
    // FORMATEO
    formatImporte(valor) {
      if (valor == null) return '0 €';
      return Math.round(valor).toLocaleString('es-ES') + ' €';
    },
    formatImporteCorto(valor) {
      if (valor == null) return '0';
      return Math.round(valor).toLocaleString('es-ES');
    },
    formatImporteConSigno(valor) {
      if (valor == null) return '0 €';
      var signo = valor >= 0 ? '+' : '';
      return signo + Math.round(valor).toLocaleString('es-ES') + ' €';
    },
    formatPorcentaje(valor) {
      if (valor == null) return '0%';
      return valor.toFixed(1) + '%';
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      var d = new Date(fecha);
      return d.toLocaleDateString('es-ES') + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },
    extraerDias(semana) {
      if (!semana || !semana.etiqueta) return '';
      var match = semana.etiqueta.match(/\((\d+-\d+)\)/);
      return match ? match[1] : '';
    },
    colorProgresionMensual(persona) {
      var resultado = persona.progresionMes || 0;
      var objetivo = persona.objetivoMensual || 0;
      if (!objetivo || objetivo <= 0 || !resultado) return {};
      var pct = (resultado / objetivo) * 100;
      if (pct >= 105) return { background: '#D6EAF8', color: '#1B4F72' };
      if (pct >= 100) return { background: '#D5F5E3', color: '#0E6251' };
      if (pct >= 95) return { background: '#FADBD8', color: '#943126' };
      return { background: '#F1948A', color: '#641E16' };
    },
    colorCeldaSemana(persona, indiceSemana) {
      var resultado = persona.resultadosSemana ? persona.resultadosSemana[indiceSemana] : 0;
      var objetivo = persona.objetivosSemana ? persona.objetivosSemana[indiceSemana] : 0;
      if (!objetivo || objetivo <= 0 || !resultado) return {};
      var pct = (resultado / objetivo) * 100;
      if (pct >= 105) return { background: '#D6EAF8', color: '#1B4F72' };
      if (pct >= 100) return { background: '#D5F5E3', color: '#0E6251' };
      if (pct >= 95) return { background: '#FADBD8', color: '#943126' };
      return { background: '#F1948A', color: '#641E16' };
    },
    calcularDiasHabilesPersona(persona) {
      if (!persona.semanas) return 0;
      return persona.semanas.reduce(function(sum, s) { return sum + (s.diasHabiles || 0); }, 0);
    },
    calcularEstadoColor(porcentaje) {
      if (porcentaje == null) return 'MUY_MALO';
      if (porcentaje > 105) return 'MUY_BUENO';
      if (porcentaje >= 100) return 'BUENO';
      if (porcentaje >= 95) return 'MALO';
      return 'MUY_MALO';
    },
    // Instrucciones
    cargarInstrucciones() {
      var self = this;
      Oea.getInstrucciones('control-cifras').then(function(res) {
        self.instrucciones = (unwrapDto(res) || []).map(function(i) { i._editando = false; return i; });
      }).catch(function() {});
    },
    inicializarInst() {
      var self = this;
      Oea.inicializarInstrucciones('control-cifras').then(function() { self.cargarInstrucciones(); })
        .catch(function(err) { avisoNoGuardado(self.$f7, 'las instrucciones iniciales', err); });
    },
    nuevaInst() {
      var self = this;
      Oea.crearInstruccion({ pantalla: 'control-cifras', titulo: 'Nueva instrucción', texto: 'Escribe aquí...', orden: self.instrucciones.length }).then(function(res) {
        if (unwrapDto(res)) { unwrapDto(res)._editando = true; self.instrucciones.push(unwrapDto(res)); self.expandedInst = unwrapDto(res).id; }
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'la instrucción nueva', err);
      });
    },
    guardarInst(inst) {
      var self = this;
      Oea.actualizarInstruccion(inst.id, { titulo: inst.titulo, texto: inst.texto }).then(function() {
        inst._editando = false;
        self.$f7.toast.create({ text: 'Instrucción guardada', position: 'top', closeTimeout: 2000 }).open();
      }).catch(function(err) {
        avisoNoGuardado(self.$f7, 'la instrucción «' + inst.titulo + '»', err);
      });
    },
    eliminarInst(inst) {
      var self = this;
      self.$f7.dialog.confirm('¿Eliminar "' + inst.titulo + '"?', 'Eliminar', function() {
        Oea.eliminarInstruccion(inst.id).then(function() {
          self.instrucciones = self.instrucciones.filter(function(i) { return i.id !== inst.id; });
        }).catch(function(err) {
          avisoNoGuardado(self.$f7, 'el borrado de «' + inst.titulo + '»', err);
        });
      });
    },
    // El orden se reordena en pantalla antes de que el servidor conteste, así que si el guardado
    // falla hay que decirlo y recargar: dejar la lista movida sin que lo esté en el servidor hace
    // creer que el orden nuevo es el que verá el siguiente que entre. Esta recarga vale porque las
    // mutaciones de instrucciones tiran la caché de 60 s del adapter; si no, restauraría la foto
    // anterior a los cambios que sí se guardaron en ese minuto.
    dropInst(idx) {
      const self = this;
      var from = this.draggingInst;
      if (from === null || from === idx) return;
      var item = this.instrucciones.splice(from, 1)[0];
      this.instrucciones.splice(idx, 0, item);
      this.draggingInst = null;
      var ids = this.instrucciones.map(function(i) { return i.id; });
      Oea.reordenarInstrucciones(ids).catch(function(err) {
        avisoNoGuardado(self.$f7, 'el orden de las instrucciones', err);
        self.cargarInstrucciones();
      });
    },
  }
};
</script>
